<script>


export default {
    name: 'InputSelect',

    props : ['label', 'valueKey', 'nameKey', 'items', 'selected', 'filter'],

    model: {
        event: 'change',
        prop: 'selected'
    },

    mounted(){
        this.$emit("change", this.selected, this.filter);
    },

    methods:
    {
        isSelected(item){
            return this.selected === item[this.valueKey];
        },
        valueChanged(event) {
            this.$emit("change", event.target.value, this.filter);
        },
    },
}

</script>

<template>
    <select class="form-input" @change="valueChanged">
        <option v-for="item in items" :value="item[valueKey]" :selected="isSelected(item)" :disabled="item.quantity === 0">@{item[nameKey]} (@{item.quantity})</option>
    </select>
</template>
